import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Question, QuestionCollectionResponse, ResponseCheckItem } from '@app/dashboard/shared/models/audit-collection-response';

@Component({
	selector: 'kpa-question-view',
	templateUrl: './question-view.component.html',
	styleUrl: './question-view.component.scss',
})
export class QuestionViewComponent {
	@Input() questionData: Question;
	@Output() validResponse = new EventEmitter<boolean>();
	validateResponse(questionData: Question) {
		let isValid = false;
		if (questionData.multipleChoice) {
			isValid = !!questionData.selectedResponseId;
		} else if (questionData.multipleAnswer) {
			isValid = questionData.responseCheckItems.some((item: ResponseCheckItem) => item.checked);
		} else if (questionData.shortResponse) {
			isValid = !!questionData.responseText;
		}

		this.validResponse.emit(isValid);
		return isValid;
	}

	GetQuestionCollection() {
		return this.questionData;
	}
}
